import axios from '../helpers/axiosConfig';

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import getBaseUrl from '../helpers/utility';

function Brigade() {
  let navigate = useNavigate();
  const baseUrl = getBaseUrl();

  const [listeBrigade, setListBrigade] = useState([]);

  useEffect(() => {
    axios.get('/brigade').then((res) => {
      setListBrigade(res.data);
    });
  }, []);

  return (
    <div className="container container pt-5">
      <div className="alert alert-warning">
        <h1>Liste des Brigades</h1>
      </div>
      <Link to="/creatbrigade" className="btn btn-outline-primary btn-sm mb-3">
        Nouveau Brigade
      </Link>
      <table className="table table-striped">
        <thead className="thead-dark">
          <tr>
            <th>N°</th>
            <th>Brigade</th>
            <th>Libelle</th>
            <th>OBS</th>
            <th>Implantation</th>
            <th>COM BRIG</th>
            <th>Images</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {listeBrigade.map((brigade, key) => {
            return (
              <tr key={key}>
                <td> {brigade.id} </td>
                <td> {brigade.name} </td>
                <td> {brigade.libelle} </td>
                <td> {brigade.observation} </td>
                <td> {brigade.implantation} </td>
                <td>
                  <a style={{ cursor: 'pointer' }} className="text-primary" onClick={() => navigate(`/personnel/${brigade.personnelId}`)}>
                    {brigade.personnelId ? <> {brigade.personnel?.nomprenom} </> : ''}
                  </a>
                </td>
                <td>
                  <img src={`${baseUrl}/images/brigades/${brigade.filename}`} width="30px" height="auto" alt="" />
                </td>

                <td>
                  <i className="fa fa-eye mr-3" onClick={() => navigate(`/brigade/${brigade.id}/effectifbrigade`)}></i>
                  <i className="fa fa-edit" onClick={() => navigate(`/brigade/edit/${brigade.id}`)}></i>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default Brigade;
